import { useRouter } from 'expo-router'
import { useCallback, useState } from 'react'

export interface InviteSignupFormData {
    name: string
    email: string
    password: string
    confirmPassword: string
}

export const useInviteSignup = (_inviteId: string) => {
    const _router = useRouter()
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const signUpAndAcceptInvite = useCallback(async (_data: InviteSignupFormData) => {
        setIsLoading(true)
        setError(null)
    }, [])

    return {
        signUpAndAcceptInvite,
        isLoading,
        error,
        clearError: () => setError(null),
    }
}
